import axios from 'axios'
import config from '../../../config'
import { OirFormLockConfig, OirLockStatus } from '../types/types'

const { apiServerUrl } = config

const oirLockPath = (tenantEsKey: string | number) =>
    `tenant-onboard/${encodeURIComponent(String(tenantEsKey))}/oir-lock-config`

const toLockConfig = (payload: unknown): OirFormLockConfig => {
    const row = (payload ?? {}) as Partial<OirFormLockConfig>
    const lock = (row.lock as OirLockStatus) ?? null
    return {
        lockAtUtc: row.lockAtUtc ?? null,
        warningLeadDays:
            typeof row.warningLeadDays === 'number' ? row.warningLeadDays : null,
        lockSource:
            row.lockSource && row.lockSource !== 'none'
                ? row.lockSource
                : (lock?.lockSource ?? 'none'),
        setByName: row.setByName ?? null,
        setByEmail: row.setByEmail ?? null,
        setAtUtc: row.setAtUtc ?? null,
        lock,
    }
}

export const getTenantOirLockConfig = async (
    tenantEsKey: string | number
): Promise<OirFormLockConfig> => {
    try {
        const { data } = await axios.get<{ success: boolean; data: unknown }>(
            `${apiServerUrl}/admin/${oirLockPath(tenantEsKey)}`
        )
        return toLockConfig((data as any)?.data ?? data)
    } catch (err: any) {
        console.error('Failed to fetch OIR form lock config', err)
        throw new Error(
            err?.response?.data?.message ||
                err?.message ||
                'Failed to fetch OIR form lock config'
        )
    }
}

export const updateTenantOirLockConfig = async (
    tenantEsKey: string | number,
    patch: { lockAtUtc?: string; warningLeadDays?: number }
): Promise<OirFormLockConfig> => {
    const { data } = await axios.put<{ success: boolean; data: unknown }>(
        `${apiServerUrl}/admin/${oirLockPath(tenantEsKey)}`,
        patch
    )
    return toLockConfig((data as any)?.data ?? data)
}
